// extracted by mini-css-extract-plugin
module.exports = {"totalsWrapper":"ncxp0u","tableWrapper":"zkmblM"};